import { DashBoardAction, DashboardActionTypes } from '@completion/actions';
import { DashboardPackage, UserSignatureAssignments } from '@completion/models';
import { DashboardCheckSheetAssignmentStatus } from '../../../../shared/models/dashboard-checksheet-status';

export const initialState: DashboardState = {
  cps: [],
  mcps: [],
  csaStatus: null,
  userSignatureAssignments: null,
};

export interface DashboardState {
  cps: DashboardPackage[];
  mcps: DashboardPackage[];
  csaStatus: DashboardCheckSheetAssignmentStatus;
  userSignatureAssignments: UserSignatureAssignments;
}

export function dashboardReducer(state: DashboardState = initialState, action: DashBoardAction): DashboardState {
  switch (action.type) {
    case DashboardActionTypes.LoadDashboardCpsSuccess:
      return {
        ...state,
        cps: [...action.cps],
      };
    case DashboardActionTypes.LoadDashboardMcpsSuccess:
      return {
        ...state,
        mcps: [...action.mcps],
      };
    case DashboardActionTypes.LoadDashboardCheckSheetAssignmentStatusSuccess:
      return {
        ...state,
        csaStatus: action.csaStatus,
      };
    case DashboardActionTypes.LoadUserSignatureAssignmentsSuccess:
      return {
        ...state,
        userSignatureAssignments: action.userSignatureAssignments,
      };
    default:
      return state;
  }
}
